$(document).ready(function(){
    
  // Build a Box small print
  
  $("#bxp-bldr-price_total").append("<div class='bbsmallprint discountsmallprint'>Your applicable discount will be applied automatically at checkout.</div> ");
  $("#bxp-bldr-bottom-wizard").append("<div class='bbsmallprint'>* Once you proceed to the Cart, you will not be able to modify your selections.</div> ");

  $(".bxp-details-price").text(function(index, text) { 
    return text.replace(':', ' '); 
  });

  $("body").on('DOMSubtreeModified', "#bxp-bldr-total_value", function() {
      setTimeout(function(){  
        $(".bxp-details-price").text(function(index, text) { 
        return text.replace(':', ' '); 
        });
      }, 500);
  });

});